import { useState } from "react";
import { Search, X, Check } from "lucide-react";
import { Input } from "./ui/input";
import { Button } from "./ui/button";

export default function EmployeePicker({ employees, value, onChange, testid, placeholder = "Tapez le nom ou prénom du salarié..." }) {
  const [query, setQuery] = useState("");
  const selected = employees.find((e) => e.id === value);
  const q = query.trim().toLowerCase();
  const filtered = (q
    ? employees.filter((e) => `${e.prenom} ${e.nom} ${e.service}`.toLowerCase().includes(q))
    : employees
  ).slice(0, 8);

  if (selected) {
    return (
      <div className="flex items-center justify-between gap-2 rounded-md border border-input bg-background px-3 py-2" data-testid={testid}>
        <span className="text-sm truncate">
          <Check className="inline h-3.5 w-3.5 text-emerald-400 mr-1.5" />
          {selected.prenom} {selected.nom} <span className="text-muted-foreground text-xs">— {selected.service}</span>
        </span>
        <Button type="button" variant="ghost" size="icon" className="h-6 w-6 shrink-0" onClick={() => { onChange(""); setQuery(""); }} data-testid={`${testid}-clear`}>
          <X className="h-3.5 w-3.5" />
        </Button>
      </div>
    );
  }

  return (
    <div className="space-y-1.5" data-testid={testid}>
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input value={query} onChange={(e) => setQuery(e.target.value)} placeholder={placeholder} className="bg-background pl-9" data-testid={`${testid}-search`} />
      </div>
      <div className="max-h-48 overflow-y-auto rounded-md border border-border divide-y divide-border/50">
        {filtered.length === 0 && <p className="text-xs text-muted-foreground text-center py-3">Aucun salarié trouvé.</p>}
        {filtered.map((e) => (
          <button key={e.id} type="button" onClick={() => { onChange(e.id); setQuery(""); }}
            data-testid={`${testid}-option-${e.id}`}
            className="w-full text-left px-3 py-2 text-sm hover:bg-secondary/60 transition-colors">
            {e.prenom} {e.nom} <span className="text-muted-foreground text-xs">— {e.service}</span>
          </button>
        ))}
        {!q && employees.length > 8 && (
          <p className="text-[11px] text-muted-foreground text-center py-1.5">Tapez pour filtrer parmi {employees.length} salariés</p>
        )}
      </div>
    </div>
  );
}
